const STATIC_HOST = 'https://static.souschaif.com';
const isDev = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

export function resolveImageUrl(src) {
    if (!src || src === 'null' || src === 'undefined') return null;

    if (src.startsWith('data:') || (src.length > 200 && !src.includes('/'))) {
        return src.startsWith('data:') ? src : `data:image/jpeg;base64,${src}`;
    }

    if (src.startsWith('http')) return src;

    const normalizedPath = src.startsWith('/') ? src : `/${src}`;

    if (isDev) return normalizedPath;

    return `${STATIC_HOST}${normalizedPath}`;
}
